/**
 * Image helpers.
 *
 * All image assets are hosted on Base44 storage — never reference the old
 * Supabase bucket or the Cloudflare Worker proxy directly.
 */

/**
 * Optimize a base44 media CDN image (media.base44.com) with on-the-fly
 * resize + WebP compression. No-op for any other host.
 *
 *   import { mediaImg } from '@/components/imageConstants';
 *   <img src={mediaImg(url, 600)} alt="..." />
 *
 * @param {string} src   The original image URL.
 * @param {number} width Target render width in px (default 800).
 * @param {number} quality JPEG/WebP quality 1-100 (default 70).
 */
export const mediaImg = (src, width = 800, quality = 70) => {
  // Proxy both media.base44.com and public base44.app file URLs (the latter
  // redirect to media.base44.com; wsrv follows redirects) — raw files are
  // uncompressed multi-hundred-KB PNGs/JPEGs otherwise.
  const proxyable = src && (src.includes('media.base44.com') || (src.includes('base44.app') && src.includes('/public/')) || /^https:\/\/(zaptec\.objects\.frb\.io|nexblue\.com|www\.lbtechreviews\.com|framerusercontent\.com)\//.test(src));
  if (!proxyable) return src;
  // media.base44.com ignores resize params and always serves the raw file
  // (verified: identical multi-MB PNG with or without ?width=...). Route
  // through the wsrv.nl image CDN, which actually resizes + converts to WebP
  // (e.g. 1.4 MB PNG -> 15 KB WebP) and caches at the edge for 1 year.
  return `https://wsrv.nl/?url=${encodeURIComponent(src)}&w=${width}&q=${quality}&output=webp`;
};